import { observer } from "mobx-react";
import _ from "lodash";
import { Button } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useStores } from "../../stores/root-store";
import CatagoryListing from "./categories-listing";
import CatagoryForm from "./category-form";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ManageCategories = observer(() => {
  const { categoryStore } = useStores();
  const { editCategory, setEditCategory } = categoryStore;
  const [showCatagoryForm, setShowCatagoryForm] = useState(false);

  const handleCatagoryFormClose = (show: boolean) => {
    setShowCatagoryForm(show);
    if (!show) setEditCategory(null);
  };

  useEffect(() => {
    if (editCategory) setShowCatagoryForm(editCategory.id > 0);
  }, [editCategory]);

  return (
    <div className="container mt-3 pb-3">
      <div className="row mb-3">
        <h5 className="mb-0 text-start">
          Product Categories
          <Button
            onClick={() => setShowCatagoryForm(true)}
            className="btn-default float-end"
          >
            <FontAwesomeIcon icon={faPlus} className="me-2" />
            New
          </Button>
        </h5>
      </div>
      <CatagoryListing />
      {showCatagoryForm && (
        <CatagoryForm
          show={showCatagoryForm}
          setShowModal={handleCatagoryFormClose}
        />
      )}
    </div>
  );
});

export default ManageCategories;
